/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Clusters Thunk
 */

import { createAction } from 'redux-actions'

import { RESET_CLUSTERS_AND_LISTABLES } from './constants'

export const resetClustersAndListables = createAction(RESET_CLUSTERS_AND_LISTABLES)
